import adminAxiosInstance from "./api/adminAxiosInstance";

/**
 * Serviço responsável por solicitar e baixar relatórios CSV do backend.
 * Suporta filtros de data, status, termos de busca e ordenação dinâmica.
 */
const downloadReport = async ({
  orderFilter,    // 'asc' ou 'desc'
  orderField,     // NOVO: 'name', 'amount' ou 'date'
  statusFilter,
  searchTerm,
  type,
  monthFilter,
  yearFilter,
  bestClientsOrder,
  consultorId,
  startDate,
  endDate,
  isRepurchase,
}) => {
  // Construção dos parâmetros de consulta (Query Strings)
  const params = new URLSearchParams({
    type: type,
    order: orderFilter,
    orderField: orderField || "date", 
    ...(statusFilter && { status: statusFilter }),
    ...(searchTerm && { filtroString: searchTerm }),
    ...(consultorId && { consultorId: consultorId }),
    ...(monthFilter && { monthFilter: monthFilter }),
    ...(yearFilter && { yearFilter: yearFilter }),
    ...(startDate && { startDate: startDate }),
    ...(endDate && { endDate: endDate }),
    ...(isRepurchase !== "" && isRepurchase !== undefined && { isRepurchase: isRepurchase }),
  });

  // Requisição ao backend usando Axios
  const response = await adminAxiosInstance.get(
    `ExtractData?${params.toString()}`,
    {
      // Crucial: define que a resposta deve ser tratada como um arquivo binário (Blob)
      responseType: "blob", 
    }
  );

  // Criação de uma URL temporária para o arquivo recebido (Blob)
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: "text/csv" })
  );
  
  // Criação de um elemento de link oculto para disparar o download
  const link = document.createElement("a");
  link.href = url;

  // Tenta recuperar o nome do arquivo enviado pelo Backend através do header Content-Disposition
  const contentDisposition = response.headers["content-disposition"];
  let fileName = `${type}_report_${new Date().toISOString()}.csv`; // Nome de fallback
  
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
    if (fileNameMatch && fileNameMatch.length === 2) {
      fileName = fileNameMatch[1];
    }
  }

  // Configura o atributo download do link e dispara o clique simulado
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();

  // Limpeza: remove o link do DOM e revoga a URL para liberar memória do navegador
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const extractDataService = {
  downloadReport,
};